import { observer } from "mobx-react-lite";
import { type ReactNode, useEffect } from "react";
import { useLocation } from "react-router";

import { LoadingWebpart } from "@mr-portfolio-components/atoms/loading-webpart";
import { useStores } from "@mr-portfolio-store/use-stores";

/** Renders the application only for a signed-in user; anyone else is sent to the Google sign-in. */
export const AuthGate = observer(function AuthGate({ children }: { children: ReactNode }): React.JSX.Element {
  const { authStore } = useStores();
  const location = useLocation();
  const returnPath = `${location.pathname}${location.search}`;
  const isChecking = authStore.status === "checking";

  useEffect(() => {
    if (isChecking) {
      void authStore.ensureSignedIn(returnPath);
    }
  }, [authStore, isChecking, returnPath]);

  if (!authStore.isSignedIn) {
    return <LoadingWebpart />;
  }

  return <>{children}</>;
});
